var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChartCompare = function SvgChartCompare(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3,290.1C3,286.7-2.4,277.2,1,261.5c3.4-14.3,12.6-19.7,27.6-16.3l50,12.2L52,298.2L17.3,290.1 M471.4,296.2 c4.8-4.1,10.4-6,16.8-5.6c6.5,0.3,11.7,2.9,15.8,7.7c10.9,10.9,10.5,21.8-1,32.7L374.5,446.2c-4.1,4.1-9.2,6.1-15.3,6.1 c-4.8,0-9.5-1.7-14.3-5.1L199,335l-27.6-7.1l25.5-40.8l18.4,4.1c4.1,1.4,6.8,2.7,8.2,4.1l134.7,104.1L471.4,296.2 M221.4,184 L42.8,464.6c-4.1,7.5-10.5,11.2-19.4,11.2c-4.1,0-8.2-1.4-12.2-4.1c-5.4-3.4-8.8-8.3-10.2-14.8c-1.4-6.5-0.3-12.1,3.1-16.8 l190.8-300c2.7-5.4,7.5-8.8,14.3-10.2c6.1-2,12.2-1,18.4,3.1l125.5,79.6L468.4,46.2c3.4-5.4,8.2-8.7,14.3-9.7 c6.1-1,11.9,0.5,17.3,4.6c12.9,8.2,15,18.7,6.1,31.6L377.5,257.4c-8.2,12.2-18.7,14.3-31.6,6.1L221.4,184"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartCompare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-compare.56a76296.svg";
export { ForwardRef as ReactComponent };